var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMvp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1110px",
    height: "464px",
    viewBox: "0 0 1110 464",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Header Bg Image") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 1110,
    height: 464
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0.385761232,
    y: 0.661883646,
    width: 37.0638931,
    height: 8.81769034
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-5",
    x: 0.567142808,
    y: 0.572783924,
    width: 49.7080983,
    height: 8.81928136
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-7",
    x: 0.334123956,
    y: 0.0636426583,
    width: 10.6887845,
    height: 10.6887845
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-9",
    x: 0.319804358,
    y: 0.653060397,
    width: 274.754902,
    height: 16.6918782
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-11",
    x: 0.197292241,
    y: 0.02956051,
    width: 274.748538,
    height: 8.39287555
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-13",
    x: 0.268890231,
    y: -0.00332690072,
    width: 274.780359,
    height: 172.547975
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-15",
    x: 0.268890231,
    y: 0.0555425582,
    width: 172.482741,
    height: 172.490697
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-17",
    x: 0.268890231,
    y: -0.00332690072,
    width: 274.780359,
    height: 172.547975
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-19",
    x: 0.483684203,
    y: -0.00332690072,
    width: 222.480414,
    height: 172.528882
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-21",
    x: 0.268890231,
    y: -0.00332690072,
    width: 274.780359,
    height: 172.547975
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-23",
    x: 0.122367349,
    y: 0.509141266,
    width: 82.5524831,
    height: 82.6399922
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.35865287,24.7338512 C3.40965542,33.4958542 0.214793971,43.833013 0.178199443,54.4199692 L0.0477319937,94.5482562 L35.0655137,57.4398133 L25.8914244,0.384170166 L9.35865287,24.7338512 Z",
    id: "path-25"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-27",
    x: 0.572783924,
    y: 0.0468640766,
    width: 20.8191046,
    height: 93.4417421
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.388220216,57.6132395 L35.1609776,94.9523875 L35.2935621,54.8241001 C35.3264485,44.2355528 32.200003,33.8777102 26.3098749,25.0775216 L9.93780112,0.619648001 L0.388220216,57.6132395 Z",
    id: "path-29"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-31",
    x: 0.208429706,
    y: 0.334123956,
    width: 24.9336024,
    height: 103.906186
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.94899748,104.054878 C-5.18528559,170.946494 4.57113393,209.809884 4.57113393,209.809884 L74.9471855,209.809884 C74.9471855,209.809884 92.2563972,90.0344011 37.6971376,0.139145931 C37.6971376,0.139145931 17.0800984,37.1632624 5.94899748,104.054878",
    id: "path-33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.94899748,104.054878 C-5.18528559,170.946494 4.57113393,209.809884 4.57113393,209.809884 L74.9471855,209.809884 C74.9471855,209.809884 92.2563972,90.0344011 37.6971376,0.139145931 C37.6971376,0.139145931 17.0800984,37.1632624 5.94899748,104.054878",
    id: "path-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.502777,27.1109045 L26.4514799,27.6502761 C22.3640301,18.2804857 17.6576555,9.06661979 12.2400743,0.139145931 C12.2400743,0.139145931 7.06592613,9.43097408 0.502777,27.1109045",
    id: "path-37"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MVP-Development-Pillar-Page",
    transform: "translate(-556.000000, -221.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Right",
    transform: "translate(556.000000, 221.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Banner"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header-Bg-Image"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#F9D94E",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "lines",
    mask: "url(#mask-2)",
    stroke: "#EDCC3B",
    strokeLinecap: "square",
    strokeWidth: 0.58
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(193.140000, 0.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.29,
    y1: -5.65953534e-17,
    x2: 0.29,
    y2: 493,
    id: "Line-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.83,
    y1: -5.65953534e-17,
    x2: 123.83,
    y2: 493,
    id: "Line-2-Copy"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 247.37,
    y1: -5.65953534e-17,
    x2: 247.37,
    y2: 493,
    id: "Line-2-Copy-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 371.49,
    y1: -5.65953534e-17,
    x2: 371.49,
    y2: 493,
    id: "Line-2-Copy-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 495.03,
    y1: -5.65953534e-17,
    x2: 495.03,
    y2: 493,
    id: "Line-2-Copy-4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 611.03,
    y1: -5.65953534e-17,
    x2: 611.03,
    y2: 493,
    id: "Line-2-Copy-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 727.03,
    y1: -5.65953534e-17,
    x2: 727.03,
    y2: 493,
    id: "Line-2-Copy-6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "header_graphic",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(473.000000, 55.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4.18168347725117,14.63281363824171",
    transform: "translate(72.899729, 120.487108)",
    stroke: "#121314",
    strokeWidth: 2.08981534
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.974971,90.999455 C109.739036,107.088319 97.7137553,117.043622 95.5849082,92.5809746 C90.331207,32.2334153 38.4099354,0.525051931 0.590285656,0.537772803",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(29.073081, 110.072854)",
    fill: "#C82010",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0186521,0.384170166 C24.8802293,0.282341912 34.6271025,0.514637615 34.6271025,0.514637615 L39.8362541,13.6425269 L31.0456119,6.6959308 L20.77846,10.3553836 L0.357122036,5.70628747 L25.0186521,0.384170166 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(29.073081, 115.713908)",
    fill: "#AA2013",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0.358713102 0.0652337248 39.8378451 8.00147319 31.0456119 1.05487706"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(29.073081, 102.840734)",
    fill: "#F13624",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0.358713102 12.9384077 38.8863874 0.100092419 34.6271025 7.74675781 0.358713102 12.9384077 31.0456119 13.928051 23.9924143 27.2580057"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(360.738116, 36.160585)",
    fill: "#44D7B6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.2307809,15.5749496 L7.69743475,15.5749496 C3.4874729,15.5749496 0.0746353557,12.162112 0.0746353557,7.95215012 C0.0746353557,3.74218831 3.48906398,0.330941823 7.69743475,0.330941823 L39.2307809,0.330941823 C43.4407427,0.330941823 46.8535802,3.74218831 46.8535802,7.95215012 C46.8535802,12.162112 43.4423338,15.5749496 39.2307809,15.5749496",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(373.611289, 41.656997)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.1765668,2.47642255 C4.17973158,3.55357455 3.30941823,4.4286611 2.23226624,4.43186061 C1.15511425,4.43502537 0.27843663,3.56630308 0.276828214,2.48756002 C0.273663431,1.4119991 1.14397678,0.535321479 2.22271984,0.532121996 C3.2966897,0.528957213 4.17336731,1.39927056 4.1765668,2.47642255",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(382.236263, 41.656997)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.91742113,2.45096549 C3.92058591,3.52811748 3.05027257,4.4047951 1.9715295,4.40640355 C0.894377511,4.4095683 0.0192909619,3.54084601 0.0160914797,2.46369402 C0.0129266962,1.38654203 0.883240051,0.509864415 1.96357417,0.506664902 C3.03754403,0.50350015 3.91263058,1.37222244 3.91742113,2.45096549",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(390.245166, 41.656997)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.27275394,2.42391736 C4.27591872,3.50106936 3.40560537,4.37774697 2.32845338,4.38094646 C1.25130138,4.38411124 0.374623767,3.51379789 0.373015351,2.4366459 C0.369850567,1.3594939 1.24016392,0.482816286 2.31731591,0.479616803 C3.3944679,0.47645202 4.26955445,1.34676537 4.27275394,2.42391736",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(60.749769, 169.520883)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.251736,25.3978752 C50.251736,39.238403 39.0307399,50.459399 25.1902121,50.459399 C11.3496844,50.459399 0.12868839,39.238403 0.12868839,25.3978752 C0.12868839,11.5562337 11.3496844,0.336351443 25.1902121,0.336351443 C39.0307399,0.336351443 50.251736,11.5573475 50.251736,25.3978752",
    id: "Path",
    fill: "#32C5FF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "14.9437443 31.4499737 20.6695151 25.7230892 14.9437443 21.4674638"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "28.2218301 26.7711246 25.151231 29.0554187 22.0238309 26.7299161 16.632184 32.2273687 33.6435481 32.2273687"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "29.6318332 25.7219755 35.3542627 31.4455187 35.3542627 21.4674638"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "25.1924396 27.1163861 35.3954714 19.5284311 35.3954714 17.0481177 14.984953 17.0481177 14.984953 19.5273174"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(418.595079, 83.603295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(0.282342, 0.059593)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.0312913,49.5528135 L7.03330975,49.5528135 C3.14856163,49.5528135 8.9927798e-14,46.4031382 8.9927798e-14,42.51839 L8.9927798e-14,5.3326187 C8.9927798e-14,2.3878727 2.3878727,7.1222816e-13 5.33373245,7.1222816e-13 L47.0312913,7.1222816e-13 C49.977151,7.1222816e-13 52.3639107,2.3878727 52.3639107,5.3326187 L52.3639107,44.2190811 C52.3650237,47.1649408 49.977151,49.5528135 47.0312913,49.5528135",
    id: "Path",
    fill: "#00DDEF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2.0850939,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "33.9224938 10.0125819 38.5801821 10.7042185 25.3366213 19.2923186 22.8685588 15.9421688 12.9762616 21.7002387"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 14.0443446,
    y: 28.3069835,
    width: 4.65323328,
    height: 9.2285043
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 20.5408285,
    y: 25.5950106,
    width: 4.65434703,
    height: 11.9404773
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 27.1988056,
    y: 22.7226581,
    width: 4.65323328,
    height: 14.8128297
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 33.925835,
    y: 20.2768706,
    width: 4.65434703,
    height: 17.2586173
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.9195859,
    y1: 15.2182335,
    x2: 38.5801821,
    y2: 10.7042185,
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2.0850939,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(472.980622, 183.261912)",
    fill: "#F13624",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.6910839,33.4115277 C65.6910839,51.5210461 51.0103138,66.2018163 32.9007954,66.2018163 C14.791277,66.2018163 0.110506735,51.519455 0.110506735,33.4115277 C0.110506735,15.3004182 14.792868,0.619648001 32.9007954,0.619648001 C51.0119049,0.619648001 65.6910839,15.3004182 65.6910839,33.4115277",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(491.350207, 202.354709)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3520235,11.7984809 L25.2263587,11.4277624 C24.9781523,10.5001707 24.6074339,9.61076458 24.1301139,8.78022789 L25.3679636,7.01255302 C25.8245997,6.36339791 25.7466374,5.48035603 25.186582,4.91870957 L23.9121378,3.64744747 C23.3441271,3.09534741 22.4626763,3.03329582 21.8214764,3.49788722 L20.0538017,4.737328 C19.224856,4.25682592 18.3338588,3.8876985 17.406267,3.63949214 L17.0419128,1.46609535 C16.9082632,0.694428125 16.2463796,0.1264174 15.465166,0.112091184 L13.6322574,0.112091184 C12.8367242,0.110506735 12.1541566,0.681699593 12.0173249,1.46609535 L11.6481975,3.58539588 C10.7174236,3.83519331 9.82960855,4.20272966 8.99907186,4.68164066 L7.23935238,3.49788722 C6.59019727,3.04284221 5.70715538,3.11921341 5.14709999,3.68085987 L3.87424682,4.95371303 C3.31260036,5.51376843 3.23622918,6.3968103 3.69286525,7.04596542 L4.93071495,8.81364026 C4.45021288,9.64258585 4.08267653,10.5335831 3.83447017,11.4611749 L1.71516964,11.8318933 C0.930773878,11.9671339 0.357989953,12.6481104 0.359574402,13.4436436 L0.359574402,15.2463219 C0.357989953,16.0418552 0.929182814,16.7228316 1.71516964,16.8580722 L3.83447017,17.2303818 C4.08267653,18.1563825 4.45180395,19.0473797 4.93071495,19.8779164 L3.69286525,21.6440001 C3.23622918,22.2931553 3.31419143,23.1777882 3.87424682,23.7362525 L5.14709999,25.0091058 C5.70874645,25.5707522 6.59019727,25.6471233 7.23935238,25.1920784 L9.00543616,23.9526376 C9.83597285,24.4347307 10.7269701,24.800676 11.6529707,25.0488824 L12.0252803,27.1681829 C12.1605209,27.9525787 12.8414974,28.5253626 13.6370306,28.5237782 L15.465166,28.5237782 C16.2606992,28.5253626 16.9416756,27.9541698 17.0769163,27.1681829 L17.4492258,25.0488824 C18.3752265,24.800676 19.2662237,24.4331397 20.0967604,23.9526376 L21.8230675,25.1666213 C22.4722226,25.6200753 23.3552645,25.5437041 23.9137288,24.9820576 L25.1881731,23.7092044 C25.7498196,23.149149 25.8261907,22.2661072 25.3695547,21.6185431 L24.131705,19.8365487 C24.610616,19.007603 24.9797434,18.1166058 25.2279497,17.1890141 L27.3536146,16.8182956 C28.1380103,16.6830549 28.7107942,16.0004875 28.7092098,15.2065453 L28.7092098,13.4038669 C28.706021,12.6115159 28.1348282,11.9337216 27.3520235,11.7984809 M14.5280278,19.1667097 C11.8438987,19.1667097 9.66572876,16.9901307 9.66572876,14.3044106 C9.66572876,11.6186904 11.8438987,9.44211151 14.5280278,9.44211151 C17.213748,9.44211151 19.3903269,11.6186904 19.3903269,14.3044106 L19.3903269,14.3314587 C19.3760073,17.0076325 17.2026105,19.1667097 14.5280278,19.1667097",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(138.133509, 44.839149)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(0.284829, 0.495706)",
    fill: "#F13624"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.6222694,48.4166907 L7.09952701,48.4166907 C3.22703009,48.4166907 0.0873784389,45.277039 0.0873784389,41.4045421 L0.0873784389,5.40825213 C0.0873784389,2.4724161 2.46745492,0.0912258836 5.40329094,0.0912258836 L56.6211556,0.0912258836 C59.5569917,0.0912258836 61.9359552,2.4724161 61.9359552,5.40825213 L61.9359552,43.1007782 C61.9370681,46.0366142 59.5581055,48.4166907 56.6222694,48.4166907",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.7051797,12.9472911 L43.9497706,12.3959866 C43.8695809,12.3803941 43.7916185,12.3024319 43.7760261,12.2222421 L43.2258353,9.46794678 C43.161238,9.14830148 42.9228962,9.07590796 42.6923507,9.30645351 L38.726299,13.2725051 C38.6104694,13.387221 38.5436446,13.6099704 38.5759433,13.7692362 L38.9702096,15.7416814 L29.5635058,24.9980293 C29.1603296,25.4023193 29.1603296,26.0560886 29.5635058,26.4592648 C29.9666821,26.8624411 30.6193376,26.8624411 31.0236276,26.4592648 L40.4314451,17.2029169 L42.4027766,17.5971832 C42.5631561,17.6283681 42.7847916,17.5615433 42.9006213,17.4468274 L46.8666729,13.4807757 C47.0961047,13.2491164 47.0237112,13.0118884 46.7051797,12.9472911",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4783251,19.6887993 L35.2090873,17.9591508 C35.2725709,17.8945535 35.2614334,17.8043401 35.1845849,17.7586764 C33.7177806,16.8944091 32.0660944,16.4611616 30.4155219,16.4611616 C28.0053744,16.4611616 25.5952267,17.3811164 23.756431,19.219912 C20.077726,22.8975032 20.077726,28.8605025 23.756431,32.5392075 C25.5952267,34.3780031 28.0053744,35.2979579 30.4155219,35.2968461 C32.8245558,35.2968461 35.2358172,34.3768894 37.0746129,32.5392075 C40.1730559,29.4396508 40.6586494,24.7207064 38.5358484,21.1110537 C38.4901848,21.0330915 38.3999713,21.0219539 38.3342602,21.0854375 L36.6046118,22.815086 C36.5400145,22.8796832 36.519967,22.9977405 36.5578345,23.0801577 C36.9543283,23.9477663 37.1703951,24.8966784 37.1703951,25.8801166 C37.1703951,27.6843861 36.467621,29.3806222 35.1912673,30.6569757 C33.9149138,31.9322156 32.2186777,32.6361035 30.4144082,32.6361035 C28.6101387,32.6361035 26.9127889,31.9322156 25.637549,30.6569757 C23.0035384,28.0218513 23.0035384,23.7361544 25.637549,21.1021437 C26.9139027,19.8257901 28.6101387,19.1219023 30.4144082,19.1219023 C31.3978464,19.1219023 32.3456448,19.3379691 33.2143672,19.7344629 C33.2967844,19.7723303 33.4137278,19.7533966 33.4783251,19.6887993",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3305275,19.1007411 L41.5719216,20.8593469 C41.5073243,20.9239443 41.4861631,21.0420014 41.521803,21.1244187 C42.1566386,22.6079291 42.49299,24.217293 42.49299,25.8790029 C42.49299,29.1055267 41.2366839,32.1393725 38.9546171,34.4203255 C36.6725504,36.7023923 33.6409321,37.9586984 30.4132944,37.9586984 C27.1856569,37.9586984 24.1540386,36.7035061 21.8719718,34.4203255 C17.1619375,29.7102912 17.1619375,22.0477146 21.8708581,17.3376802 C24.1529248,15.0567272 27.1856569,13.7993073 30.4132944,13.7993073 C32.0738906,13.7993073 33.685482,14.1356587 35.1678787,14.771608 C35.2502959,14.807248 35.3694668,14.784973 35.4329504,14.7214895 L37.1915563,12.9617698 C37.2561535,12.8982863 37.2427886,12.8125278 37.1625988,12.7713192 C35.0509353,11.682075 32.7321149,11.1385666 30.4132944,11.1374529 C26.639921,11.1374529 22.8676613,12.5775273 19.98974,15.4554485 C14.2327839,21.2124046 14.2327839,30.5456011 19.98974,36.3025572 C22.868775,39.1815922 26.6410347,40.6205528 30.4132944,40.6205528 C34.1855542,40.6205528 37.9578139,39.1815922 40.8357351,36.3025572 C45.4845134,31.6548927 46.3788519,24.6761565 43.5198644,19.1296985 C43.4797695,19.0495087 43.394011,19.0372575 43.3305275,19.1007411",
    id: "Path",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(454.755679, 312.138294)",
    fill: "#FFD943",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.7674834,5.82084425 L3.40329115,5.82084425 C1.82972642,5.82084425 0.553691127,4.54480895 0.553691127,2.97124422 C0.553691127,1.3976795 1.82972642,0.1216442 3.40329115,0.1216442 L68.7674834,0.1216442 C70.3410481,0.1216442 71.6170833,1.3976795 71.6170833,2.97124422 C71.6170833,4.54480895 70.3410481,5.82084425 68.7674834,5.82084425",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    opacity: 0.38,
    transform: "translate(340.922106, 93.438978)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0424003,9.47957396 L4.79619745,9.47957396 C2.36027471,9.47957396 0.387352298,7.50665154 0.387352298,5.0707288 C0.387352298,2.63639712 2.36027471,0.661883646 4.79619745,0.661883646 L33.0424003,0.661883646 C35.476732,0.661883646 37.4512454,2.63639712 37.4512454,5.0707288 C37.4496544,7.50665154 35.476732,9.47957396 33.0424003,9.47957396",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.152646019,
    mask: "url(#mask-4)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    opacity: 0.38,
    transform: "translate(164.313729, 136.397772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8648049,9.39206531 L4.97598796,9.39206531 C2.54165628,9.39206531 0.567142808,7.41755182 0.567142808,4.98322015 C0.567142808,2.5472974 2.54165628,0.574374991 4.97598796,0.574374991 L45.8648049,0.574374991 C48.3007276,0.574374991 50.27365,2.5472974 50.27365,4.98322015 C50.27365,7.41755182 48.3007276,9.39206531 45.8648049,9.39206531",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.152925037,
    mask: "url(#mask-6)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    opacity: 0.0819614955,
    transform: "translate(26.035636, 281.329502)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.6373227,0.572887999 L3.2211409,0.572887999 C1.73349376,0.572887999 0.52905646,1.77891637 0.52905646,3.26497245 L0.52905646,3.57841254 C0.52905646,5.06605967 1.73349376,6.27049698 3.2211409,6.27049698 L49.6373227,6.27049698 C51.1249698,6.27049698 52.3294071,5.06446861 52.3294071,3.57841254 L52.3294071,3.26497245 C52.3294071,1.77891637 51.1249698,0.572887999 49.6373227,0.572887999",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    opacity: 0.114583333,
    transform: "translate(465.748585, 286.391987)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7185508,0.407705934 L2.98302138,0.407705934 C1.49537424,0.407705934 0.292528005,1.61214324 0.292528005,3.09819931 L0.292528005,3.41323047 C0.292528005,4.90087761 1.49696532,6.10372385 2.98302138,6.10372385 L26.7185508,6.10372385 C28.2061979,6.10372385 29.4074563,4.89928654 29.4074563,3.41323047 L29.4074563,3.09819931 C29.4090442,1.61214324 28.2061979,0.407705934 26.7185508,0.407705934",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(521.435916, 135.963873)",
    fill: "#FFD943",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.60821731,4.82046948 C9.60821731,7.4091346 7.51119169,9.50775127 4.92252657,9.50775127 C2.33386144,9.50775127 0.235244785,7.4091346 0.235244785,4.82046948 C0.235244785,2.23180435 2.33386144,0.133187691 4.92252657,0.133187691 C7.51119169,0.133187691 9.60821731,2.23180435 9.60821731,4.82046948",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    opacity: 0.150995164,
    transform: "translate(316.766895, 0.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.83156291,5.00273069 C9.83156291,7.59139582 7.73294624,9.69001247 5.14428112,9.69001247 C2.55561599,9.69001247 0.458590403,7.59139582 0.458590403,5.00273069 C0.458590403,2.41406557 2.55561599,0.315448909 5.14428112,0.315448909 C7.73294624,0.315448909 9.83156291,2.41406557 9.83156291,5.00273069",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    opacity: 0.38,
    transform: "translate(501.185977, 35.437392)",
    stroke: "#000000",
    strokeWidth: 4.18168355
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.289198, 0.578550)",
    opacity: 0.428013393
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6.56690965,
    cy: 6.90667472,
    r: 6.50109755
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    opacity: 0.38,
    transform: "translate(0.000000, 324.722227)",
    stroke: "#000000",
    strokeWidth: 4.18168355
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.289241, -0.000044)",
    opacity: 0.327938988
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6.71806097,
    cy: 6.61941484,
    r: 6.50109755
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    opacity: 0.38,
    transform: "translate(55.687331, 54.240907)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.433879, 0.144621)",
    opacity: 0.211704799
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7865627,5.55195402 C10.7865627,8.50338233 8.39359874,10.8963462 5.44217044,10.8963462 C2.49074216,10.8963462 0.0977782028,8.50338233 0.0977782028,5.55195402 C0.0977782028,2.60052574 2.49074216,0.207561789 5.44217044,0.207561789 C8.39359874,0.207561789 10.7865627,2.60052574 10.7865627,5.55195402",
    id: "Path"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    opacity: 0.38,
    transform: "translate(543.855400, 270.047354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0244995,5.40803489 C11.0244995,8.35787209 8.63153554,10.7508361 5.68010725,10.7508361 C2.72867898,10.7508361 0.335715023,8.35628107 0.335715023,5.40803489 C0.335715023,2.45660661 2.72867898,0.0636426583 5.68010725,0.0636426583 C8.63153554,0.0636426583 11.0244995,2.45660661 11.0244995,5.40803489",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.409574963,
    mask: "url(#mask-8)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(115.858523, 387.786272)",
    fill: "#2B2C2E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.462249,21.0402628 L20.8270599,21.2741644 C9.43979729,21.283696 0.20206544,12.0602838 0.192519041,0.673021111 L342.063393,0.405721947 C342.072924,11.7913935 332.847921,21.0307164 321.462249,21.0402628",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(115.858523, 387.786272)",
    fill: "#525354",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.457476,13.9409243 L20.8206956,14.1764021 C11.9329985,14.1827664 4.37543276,8.5535733 1.47491861,0.673021111 L0.192519041,0.673021111 C0.20206544,12.0602838 9.43979729,21.283696 20.8270599,21.2741644 L321.462249,21.0402628 C332.847921,21.0307164 342.072924,11.7929845 342.063393,0.405721947 L340.782569,0.407313013 C337.891601,8.29263838 330.345173,13.93456 321.457476,13.9409243",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(260.645571, 387.786272)",
    fill: "#D7D7D7",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.7686177,7.42709822 L6.92591229,7.45892446 C3.11371706,7.46210169 0.0222749304,4.37384169 0.0190927975,0.56164646 L52.6643047,0.520278732 C52.6674818,4.3308829 49.5792219,7.42391609 45.7686177,7.42709822",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(133.360254, 183.261912)",
    fill: "#525354",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.969225,204.944403 L0.284800896,205.184653 L0.140002828,20.0736176 C0.132058516,9.45484003 8.73336381,0.839215173 19.3537324,0.829668777 L287.578898,0.621223206 C298.199266,0.611692669 306.814892,9.21458902 306.824438,19.8349576 L306.969225,204.944403 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(149.270919, 199.895788)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.264117032,
    y: 0.0825906883,
    width: 274.742173,
    height: 172.355456
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    opacity: 0.16,
    transform: "translate(149.270919, 355.097088)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D3D4DD",
    fillRule: "nonzero",
    mask: "url(#mask-10)",
    x: 0.326168624,
    y: 0.761252916,
    width: 274.742173,
    height: 16.4754932
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    opacity: 0.16,
    transform: "translate(149.270919, 199.842217)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D3D4DD",
    fillRule: "nonzero",
    mask: "url(#mask-12)",
    x: 0.200474373,
    y: 0.137753029,
    width: 274.740582,
    height: 8.17808159
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    opacity: 0.8,
    transform: "translate(149.270919, 199.895788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-11"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.38,
    mask: "url(#mask-14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-13"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#DEE2E7",
    fillRule: "nonzero",
    mask: "url(#mask-16)",
    points: "91.8252183 0.119185217 0.270481298 91.8187095 0.332532889 172.544648 0.531416196 172.544648 172.750041 0.0555425582"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-15"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.38,
    mask: "url(#mask-18)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.801512, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.655551, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Path-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-20",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-17"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#DEE2E7",
    fillRule: "nonzero",
    mask: "url(#mask-20)",
    points: "0.483684203 172.525556 50.7454736 172.485779 222.964098 -0.00332690072 172.703899 0.0364497607"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-22",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-19"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.38,
    mask: "url(#mask-22)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(192.211720, 89.130435)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.162679, 0.113929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Path-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-24",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-21"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#DEE2E7",
    fillRule: "nonzero",
    mask: "url(#mask-24)",
    points: "50.3825656 83.1109473 82.6748507 50.7693396 82.6350737 0.5075502 0.120776283 83.1507243"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(265.418770, 242.131370)",
    fill: "#06D2FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0.101828253 0.250520583 1.04692173 12.6353819 35.7655829 12.6353819 37.6414503 0.723067321"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(222.459976, 133.938851)",
    fill: "#0042B6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8898334,0.384170166 L9.35865287,24.7338512 C3.41124649,33.4958542 0.214793971,43.833013 0.178199443,54.4215603 L0.0477319937,94.5482562 L35.0655137,57.4398133 L25.8898334,0.384170166 Z",
    id: "Path"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(222.459976, 133.938851)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-26",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-23"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.63,
    mask: "url(#mask-26)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.950851, -8.525520)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.368747, 0.570188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Path-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-28",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3124825,0.0468640766 C11.3124825,0.0468640766 -5.78034444,54.1765361 3.15985799,93.4886061 L21.3902975,71.7100884 L16.1238675,4.53526255 L11.3124825,0.0468640766 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.353492374,
    mask: "url(#mask-28)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(309.968631, 133.938851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.93780112,0.619648001 L26.3098749,25.0775216 C32.200003,33.8777102 35.3280396,44.2355528 35.2936125,54.8241001 L35.1609776,94.9523875 L0.388220216,57.6132395 L9.93780112,0.619648001 Z",
    id: "Path",
    fill: "#0042B6",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(309.968631, 133.938851)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-30",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-27"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.63,
    mask: "url(#mask-30)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.425331, -18.601134)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.652132, 0.376191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Path-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-32",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1024618,0.334123956 C11.1024618,0.334123956 30.3257267,60.4573433 23.7864435,104.238719 L0.210020772,73.2479265 L10.2305573,15.4492553 L11.1024618,0.334123956 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.514439174,
    mask: "url(#mask-32)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(244.734907, 14.608867)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.6955465,0.139145931 C37.6955465,0.139145931 17.0800984,37.1616713 5.94740642,104.054878 C-5.18528559,170.946494 4.57113393,209.809884 4.57113393,209.809884 L74.9471855,209.809884 C74.9471855,209.809884 92.2563972,90.0344011 37.6955465,0.139145931",
    id: "Path",
    fill: "#06D2FF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(244.734907, 14.608867)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-34",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-31"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#00BDE6",
    fillRule: "nonzero",
    mask: "url(#mask-34)",
    points: "37.3630136 -6.5003744 36.7043121 219.012612 107.864759 220.931438 81.9033284 1.46450429"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-36",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-33"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#0042B6",
    fillRule: "nonzero",
    mask: "url(#mask-36)",
    points: "67.1923275 27.9668983 13.8645531 26.8611071 36.6374873 -5.76371063"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(270.191969, 14.608867)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGID_43_",
    fill: "#0042B6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.502777,27.1109045 L26.4514799,27.6502761 C22.3640301,18.2804857 17.6576555,9.06661979 12.2400743,0.139145931 C12.2400743,0.139145931 7.06592613,9.43097408 0.502777,27.1109045",
    id: "path-35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-38",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-37"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-35"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#00338D",
    fillRule: "nonzero",
    mask: "url(#mask-38)",
    points: "12.6378409 -13.9624761 11.7834382 35.3669484 35.6557993 30.5491991"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(259.777717, 97.344323)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(0.867855, 0.000000)",
    fill: "#F9D94F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.4379302,23.0154994 C45.3978993,35.4226357 35.3057647,45.4479455 22.8986284,45.406832 C10.4914922,45.36521 0.466182472,35.2746665 0.508867053,22.8675303 C0.548917928,10.460394 10.6394614,0.436675359 23.0465977,0.476216769 C35.4537338,0.517819748 45.4790436,10.6083633 45.4379302,23.0154994",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(8.678544, 7.955332)",
    fill: "#F13624",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.4299782,15.0331191 C29.4011723,23.1284652 22.8189304,29.6693394 14.7235842,29.64403 C6.62823809,29.6168342 0.0873638874,23.0330012 0.112673265,14.936064 C0.13986908,6.84230892 6.72211102,0.30143471 14.8190482,0.326744088 C22.9159855,0.353939902 29.4568596,6.9377729 29.4299782,15.0331191",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(0.000000, 126.562105)",
    fill: "#0042B6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "3.66654027 0.421632611 45.6006878 0.420041545 48.836917 21.7848819 0.430311093 21.6448681"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(281.329435, 223.906427)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#00378C",
    fillRule: "nonzero",
    points: "0.109783586 0.420041545 0.669288942 21.7848819 27.2851987 21.7848819 23.8659968 0.420041545"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(200.908257, 254.136689)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(36.594528, 0.000000)",
    fill: "#FFD943",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "28.8976722 0.630062317 0.215517121 118.238513 92.4225914 118.127138 63.6163333 0.630062317"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(58.869459, 0.000000)",
    fill: "#FFE083",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "14.2248573 0.630062317 0.365077368 118.303746 47.8838681 118.138276 33.4544865 0.630062317"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(67.692645, 0.000000)",
    fill: "#FF9600",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.84239603,0.630062317 C5.84239603,0.630062317 -10.987905,32.5579929 15.3999323,59.4676999 C15.3999323,59.4676999 40.1807923,40.1903387 24.9192829,0.630062317 L5.84239603,0.630062317 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(72.465845, 0.000000)",
    fill: "#FFD943",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.77241857,0.630062317 C3.77241857,0.630062317 -6.98319068,23.8898629 10.9863139,39.9214485 C10.9863139,39.9214485 26.5548991,27.4522606 17.4635454,0.630062317 L3.77241857,0.630062317 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(76.371190, 0.000000)",
    fill: "#FF9600",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.16934673,0.630062317 C2.16934673,0.630062317 -4.41130413,14.8589697 6.58296508,24.6663033 C6.58296508,24.6663033 16.1070889,17.0387307 10.5447206,0.630062317 L2.16934673,0.630062317 L2.16934673,0.630062317 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(8.823187, 81.867602)",
    fill: "#FFD943",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7436026,8.36495951 C15.7436026,12.6481104 12.2718955,16.1214085 7.98874467,16.1214085 C3.70559378,16.1214085 0.232295703,12.6481104 0.232295703,8.36495951 C0.232295703,4.08339968 3.70559378,0.610101602 7.98874467,0.610101602 C12.2718955,0.610101602 15.7436026,4.08339968 15.7436026,8.36495951",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(134.517437, 74.780123)",
    fill: "#FFD943",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4079465,6.22425198 C11.4079465,9.31410308 8.9020168,11.8216238 5.80739257,11.8216238 C2.71754151,11.8216238 0.210020772,9.31569409 0.210020772,6.22425198 C0.210020772,3.13280985 2.71595044,0.625289117 5.80739257,0.625289117 C8.9020168,0.626880184 11.4079465,3.13280985 11.4079465,6.22425198",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(23.865997, 99.369332)",
    fill: "#FFD943",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.52568669,3.43106243 C6.52568669,5.10327328 5.17009807,6.4588619 3.49947829,6.4588619 C1.82885851,6.4588619 0.47167882,5.10168221 0.47167882,3.43106243 C0.47167882,1.76044265 1.82885851,0.40485403 3.49947829,0.40485403 C5.17009807,0.40485403 6.52568669,1.76044265 6.52568669,3.43106243",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(133.649583, 97.778266)",
    fill: "#FFD943",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.676838,3.4278803 C6.676838,5.10009114 5.32124938,6.4540887 3.6506296,6.4540887 C1.97682769,6.4540887 0.622830134,5.09850008 0.622830134,3.4278803 C0.622830134,1.75407838 1.97841876,0.40008083 3.6506296,0.40008083 C5.32284045,0.40008083 6.676838,1.75566945 6.676838,3.4278803",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(157.462008, 96.856841)",
    fill: "#FFD943",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.0462507,3.03826718 C6.0462507,4.69774949 4.70020848,6.04538279 3.04072616,6.04538279 C1.37965278,6.04538279 0.0336105601,4.69774949 0.0336105601,3.03826718 C0.0336105601,1.3771938 1.37965278,0.0311515765 3.04072616,0.0311515765 C4.70020848,0.0327426429 6.0462507,1.3771938 6.0462507,3.03826718",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(0.000000, 105.010386)",
    fill: "#FFD943",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.42385844,3.37306089 C6.42385844,5.04527173 5.06826982,6.39926929 3.39765003,6.39926929 C1.72384812,6.39926929 0.369850567,5.04368067 0.369850567,3.37306089 C0.369850567,1.70244111 1.72543919,0.345261421 3.39765003,0.345261421 C5.06986088,0.345261421 6.42385844,1.70085005 6.42385844,3.37306089",
    id: "Path"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMvp);
export default __webpack_public_path__ + "static/media/mvp.d333528609ea5f3629b828eded1ffe57.svg";
export { ForwardRef as ReactComponent };